import { useEffect, useState } from "react";
import { LawsuitAppealIncident, LawsuitInfo } from "@customTypes/responses/lawsuit";
import { WithPos } from "@customTypes/generics";
import { addAppealsIncidentsPos } from "../helper";

const separateByType = (movements: LawsuitAppealIncident[]) => {
  const appeals: LawsuitAppealIncident[] = [];
  const incidents: LawsuitAppealIncident[] = [];

  movements.forEach((movement) => {
    if (movement.caseType === "CTE_APPEAL") return appeals.push(movement);
    return incidents.push(movement);
  });

  return { appeals, incidents };
};

type OrganizedMovementsState = {
  appeals: WithPos<LawsuitAppealIncident>[];
  incidents: WithPos<LawsuitAppealIncident>[];
};

const initialOrganizedMovementState: OrganizedMovementsState = {
  appeals: [],
  incidents: [],
};

const useAppealIncidentsOrganizer = (lawsuit: LawsuitInfo) => {
  const [organizedMovements, setOrganizedMovements] = useState(initialOrganizedMovementState);

  useEffect(() => {
    const allMovements = separateByType(lawsuit.appealIncidents);
    setOrganizedMovements(addAppealsIncidentsPos(allMovements, lawsuit.id));
  }, [lawsuit]);

  return organizedMovements;
};

export default useAppealIncidentsOrganizer;
